<template>
  <div class="gestion-economica">
    <b-container>
      <b-row class="center">
        <b-col cols="7">
          <div class="button big"></div>
        </b-col>
        <b-col>
          <div class="text">
            <h1>MANUAL DE GESTIÓN ECONÓMICA</h1>
            <p>
              Llevar al día nuestra Gestión Económica es necesario para cumplir con nuestras
              obligaciones como asociación. Debemos asumir responsabilidades en la realización
              de determinadas gestiones compartidas de las que el Movimiento ha de rendir
              cuentas y responder ante la legislación vigente. Es por ello que se redacta este
              manual para la adecuada gestión económica, un deber de los Centros para cumplir
              con sus obligaciones como parte del Movimiento.
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row class="footer">
        <b-col cols="auto" class="mr-auto">
          <router-link to="/gestion">
            <div class="button small back"></div>
          </router-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/manual/gestion-economica.pdf" v-b-tooltip.topright title="Manual de gestión económica">
            <div class="button small download manual"></div>
          </b-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/guia/secretaria-virtual.pdf" v-b-tooltip title="Guía de la Secretaría Virtual">
            <div class="button small download guia"></div>
          </b-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/guia/lopd.pdf" v-b-tooltip.topleft title="Guía de la LOPD">
            <div class="button small download guia"></div>
          </b-link>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>

export default {
  name: 'gestion-economica'
}
</script>

<style lang="scss" scoped>
@import '../styles/common.scss';
</style>
